import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl, FormArray } from '@angular/forms';
import { ActivatedRoute, Params } from '@angular/router'
import { Router } from '@angular/router';

@Component({
  selector: "app-beca-formulario",
  templateUrl: "./formulario.component.html"
})
export class FormularioComponent implements OnInit{
  dato: FormGroup;
  tieneid: boolean = false;
  tipos = [
    { id: "INSCRIPCION", nombre: "Inscripción" },
    { id: "REINSCRIPCION", nombre: "Reincripción" },
    { id: "COLEGIATURA", nombre: "Colegiatura" },
    { id: "REINCORPORACION", nombre: "Reincorporación" }
  ];

  form_becas_detalles = {
    articulos: this.fb.array([]),
    articulos_id: ["", [Validators.required]],
    carreras_id: ["", [Validators.required]],
    nivel: ["", [Validators.required]],
    tipo: ["", [Validators.required]],
    importe: ["0.00", [Validators.required]]
  };
  tamano;
  max = 0;
  constructor(private fb: FormBuilder, private route: ActivatedRoute) {}

  ngOnInit() {
    this.dato = this.fb.group({
      nombre: ["", [Validators.required]],
      descripcion: ["", [Validators.required]],
      tipos_becas_id: [2],
      es_porcentaje: [false],
      requiere_promedio: [false],
      promedio_requerido: [{ value: "", disabled: true }, [Validators.required]],
      becas_detalles: this.fb.array([])
    });
    this.route.params.subscribe(params => {
      if (params["id"]) {
        this.tieneid = true;
      }
    });
    //Solo si se va a cargar catalogos poner un <a id="catalogos" (click)="ctl.cargarCatalogo('modelo','ruta')">refresh</a>
    document.getElementById("catalogos").click();
  }

  quitarAllMetodo = function() {
    this.dato.controls.becas_detalles = this.fb.array([]);
  };
  homogenea() {
    if (this.dato.get("colegiatura_homogenea").value == 1) {
      this.dato.controls.becas_detalles = this.fb.array([]);
      (<FormArray>this.dato.controls.becas_detalles["controls"]).push(
        this.fb.group(this.form_becas_detalles)
      );
    }
  }
  pintar_tabla(carrera, modelo) {
    if (!this.tieneid) {
      carrera.forEach(element => {
        let formulario = { articulos: this.fb.array([
            this.fb.group({
              tipo: [this.tipos[0]],
              articulos_id: ["db61c2cb92dde2df6e62b4b0744f9dce"],
              importe: ["0.00", [Validators.required]]
            }),
            this.fb.group({
              tipo: [this.tipos[1]],
              articulos_id: ["83dae74b6269ce625f4babc3fa613be2"],
              importe: ["0.00", [Validators.required]]
            }),
            this.fb.group({
              tipo: [this.tipos[2]],
              articulos_id: ["12a00afca32cafa9f493f73f2b7f8bcf"],
              importe: ["0.00", [Validators.required]]
            }),
            this.fb.group({
              tipo: [this.tipos[3]],
              articulos_id: ["549ff7cf2b0d4d82ca99ca7999263207"],
              importe: ["0.00", [Validators.required]]
            })
          ]), carreras_id: [element.id, [Validators.required]], carreras_nombre: [element.nombre, [Validators.required]] };
        (<FormArray>modelo).push(this.fb.group(formulario));
      });
    }
  }

  toggleCambiarPorcentaje(tipo) {
    if (tipo == 1) {
      this.max = 100;
      this.dato.controls.becas_detalles["controls"].forEach(item => {
        item.controls.articulos.controls.forEach((element, key)=> {
          if(element.value.importe > 99){
            item.controls.articulos.controls[key].controls.importe.patchValue(0);
          }
        });
      });
    } else{
      this.max = 3000;
    }
  }

  toggleCambiarRequierePromedio() {
    if (!this.dato.controls.requiere_promedio.value) {
      this.dato.get("promedio_requerido").enable();
    } else {
      this.dato.get("promedio_requerido").disable();
      this.dato.controls.promedio_requerido.patchValue('');
    }
  }
}
